import React, { useContext } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import EditIcon from 'components/Icons/EditIcon';
import GenericList from 'components/List/GenericList';
import { EntityColumnType } from 'components/List/TableCellWithConfigurableStyle';
import { useBuyersWithFilter } from 'hooks';
import { Routes } from 'routes';
import { TableFilterContext } from 'tableFilterContext';
import ActionButton from 'components/Buttons/ActionButton';

const columns = [
  {
    columnPath: '',
    headerTranslationKey: 'buyers.action',
    type: 'action' as EntityColumnType,
    disableSort: true,
    style: {
      columnWidth: '5%',
    },
  },
  {
    columnPath: 'name',
    headerTranslationKey: 'buyers.buyer',
    style: {
      columnWidth: '25%',
      textAlign: 'center',
    },
  },
  {
    columnPath: 'postalCode',
    headerTranslationKey: 'buyers.postalCode',
    type: 'number' as EntityColumnType,
    style: {
      columnWidth: '35%',
      paddingLeft: '3rem',
      textAlign: 'center',
    },
  },
  {
    columnPath: 'city',
    headerTranslationKey: 'buyers.city',
    disableSort: true,
    style: {
      columnWidth: '30%',
      textAlign: 'center',
    },
  },
];

const BuyerList: React.FC = () => {
  const { page, itemsPerPage, order, orderBy } = useContext(TableFilterContext);
  const [buyerList, total] = useBuyersWithFilter({ page, itemsPerPage }, { order, orderBy });
  const { t } = useTranslation();

  return (
    <GenericList
      entities={buyerList}
      columns={columns}
      total={total}
      detailsLink={Routes.Buyers}
      biggerSideMargins
      generateAvailableActions={({ id }) => {
        const disabled = true;
        const linkTo = { pathname: `/`, state: { referer: '' } };

        return [
          {
            title: t('update'),
            onClick: () => {},
            disabled,
            action: (
              <ActionButton
                variant="outlined"
                icon={EditIcon}
                component={Link}
                data-qa-id={'edit-button'}
                to={linkTo}
                disabled={disabled}
              />
            ),
          },
          {
            title: t('delete'),
            onClick: () => {},
            disabled,
            action: (
              <ActionButton
                variant="outlined"
                icon={DeleteIcon}
                data-qa-id={'delete-button'}
                onClick={() => {}}
                disabled={disabled}
              />
            ),
          },
        ];
      }}
    />
  );
};
export default BuyerList;
